import React, { Component } from "react";
import {
	stepByStepBanner,
	quickStartBanner
} from "../images";

class Banner extends Component {
	render() {
		const img = (this.props.src === "stepByStepBanner") ? stepByStepBanner : quickStartBanner;
		return (
			<div className="container-fluid p-0 m-0">
				<div className="row p-0 m-0">
					<div className="col-12 p-0 m-0">
						<img className="ml-0 pl-0 mr-0 ml-0 mt-5 pt-5 img-fluid smart-phone-banner" src={img} alt="banner"/>
					</div>
				</div>
			</div>
		);
	}
}

export default Banner;